import { css } from '@emotion/react'
import { font } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const cardContainer = css`
  background-color: #1a1a1a;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #2a2a2a;
  }
  
  ${MQ.PHONES} {
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 8px;
  }
`

export const cardContent = css`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
`

export const leftSection = css`
  flex-shrink: 0;
`

export const logoContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 113px;
  min-height: 113px;
  
  ${MQ.PHONES} {
    width: 94px;
    min-height: 94px;
  }
`

export const logo = css`
  max-width: 113px;
  max-height: 113px;
  border-radius: 8px;
  object-fit: contain;
  
  ${MQ.PHONES} {
    max-width: 94px;
    max-height: 94px;
  }
`

export const logoPlaceholder = css`
  width: 113px;
  height: 113px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #e0e0e0;
  
  ${MQ.PHONES} {
    width: 94px;
    height: 94px;
  }
`

export const contentSection = css`
  flex: 1;
  min-width: 0;
`

export const categoryTagContainer = css`
  margin-bottom: 6px;
`

export const categoryTag = css`
  font-family: ${font.family};
  color: #ffeb3b;
  font-size: 11px;
  font-weight: normal;
  
  ${MQ.PHONES} {
    font-size: 11px;
  }
`

export const categoryLinesContainer = css`
  margin-bottom: 8px;
`

export const categoryLine = css`
  margin-bottom: 2px;
  line-height: 1.2;
  
  ${MQ.PHONES} {
    margin-bottom: 1px;
  }
`

export const nameContainer = css`
  margin-top: 2px;
`

export const beneficiaryName = css`
  color: white !important;
  line-height: 1.2;
  margin: 4px 0;
  
  ${MQ.PHONES} {
    font-size: 14px !important;
  }
`

export const statsContainer = css`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const statItem = css`
  display: flex;
  align-items: center;
  
  ${MQ.PHONES} {
    font-size: 11px;
  }
`

export const actionSection = css`
  position: absolute;
  top: 0;
  right: 0;
`

export const favoriteButton = css`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  transition: all 0.2s ease;
  border-radius: 4px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
` 